var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(-0.041 -0.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_528",
    "data-name": "Ellipse 528",
    transform: "translate(0.041 0.329)",
    fill: "#0c0e0d",
    stroke: "#009ee2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 37.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "attachment-09",
    d: "M18.353,21.539V7.41c0-4.086-3.6-7.41-8.057-7.41H8.057C3.6,0,0,3.324,0,7.41V35a5.872,5.872,0,0,0,5.864,5.864H7.6A5.872,5.872,0,0,0,13.459,35V11.8a3.374,3.374,0,0,0-3.37-3.37h0a3.374,3.374,0,0,0-3.37,3.37V29.365",
    transform: "matrix(0.891, 0.454, -0.454, 0.891, 41.517, 16.344)",
    fill: "none",
    stroke: "#009ee2",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.0fb372c41357597140cb465ccfaa7d96.svg";
export { ForwardRef as ReactComponent };